import { combineReducers } from 'redux';

import * as C from '../constants/merchantTypes';
import { SUBMIT_DOCUMENTS_SUCCESS } from '../constants/documentTypes';

export const GENERIC_STATE = {
  data: {},
  fetching: false,
  success: false,
  error: null
};

const ResellerInitialState = {
  data: {
    reseller_plan: {
    }
  }
}

const CLIENT_APP_DEFAULT_STATE = {
  data: [],
  fetching: false,
  success: false,
  error: null,
}

const MERCHANT_LISTING_STATE = {
  ...GENERIC_STATE,
  data: {
    count: 0,
    first_page: true,
    last_page: true,
    merchants: [],
    next_page: null,
    prev_page: null,
    per_page: 10,
    total_pages: 0
  }
},

 INVITEE_LISTING_STATE = {
  ...GENERIC_STATE,
  data: {
    count: 0,
    first_page: true,
    last_page: true,
    invites: [],
    next_page: null,
    prev_page: null,
    per_page: 10,
    total_pages: 0
  }
},

 REFER_MERCHANT_STATE = {
  ...GENERIC_STATE
};/** * merchant listing reducer responsible for listing actions * @param  {object} state  initial state * @param  {object} action redux action object * @return {object}        redux store state */
export function merchantListReducer(state = MERCHANT_LISTING_STATE, action) {
  switch (action.type) {
    case C.FETCH_MERCHANT_LIST_INITIATED:
      return { ...state,
fetching: true };
    case C.FETCH_MERCHANT_LIST_SUCCESS:
      return {
        ...state,
data: action.payload,
fetching: false,
success: true
      };
    case C.FETCH_MERCHANT_LIST_FAILURE:
      return { ...state,
fetching: false,
error: action.payload };
    case C.UPDATE_MERCHANT_DATA:
      const merchantData = { ...state.data };
      merchantData.merchants = [];
      merchantData.total_count = 0;
      return {
        ...state,
data: { ...merchantData }
      }
    default:
      return state;
  }
}


export function resellerReducer(state = ResellerInitialState, action) {
  switch (action.type) {
    case C.FETCH_RESELLER_DETAILS_INITIATED:
    case C.UPDATE_RESELLER_DETAILS_INITIATED:
      return {
        ...state,
        fetching: true,
        success: false,
        error: null
      };
    case C.FETCH_RESELLER_DETAILS_SUCCESS:
    case SUBMIT_DOCUMENTS_SUCCESS:
    case C.UPDATE_RESELLER_DETAILS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        fetching: false,
        success: true,
        error: null
      };
    case C.UPDATE_RESELLER_DETAILS_FAILURE:
      return { ...state,
fetching: false,
success: false,
error: action.payload };
    case C.FETCH_RESELLER_DETAILS_FAILURE:
      return {
        ...state,
        fetching: false,
        success: false,
        error: action.payload
      };
    default:
      return state;
  }
}

export function inviteUser(state = GENERIC_STATE, action) {
  switch (action.type) {
    case C.INVITE_USER__INITIATED:
      return {
        ...state,
fetching: true,
success: false,
error: null
      };
    case C.INVITE_USER_SUCCESS:
      return {
        ...state,
data: action.payload,
fetching: false,
success: true,
error: null
      };
    case C.INVITE_USER_FAILURE:
      return {
        ...state,
fetching: false,
success: false,
error: action.payload
      };
    default:
      return state;
  }

}

export function inviteUserUpdate(state = GENERIC_STATE, action) {
  switch (action.type) {
    case C.INVITE_USER_UPDATE_INITIATED:
      return {
        ...state,
fetching: true,
success: false,
error: null
      };
    case C.INVITE_USER_UPDATE_SUCCESS:
      return {
        ...state,
data: action.payload,
fetching: false,
success: true,
error: null
      };
    case C.INVITE_USER_UPDATE_FAILURE:
      return {
        ...state,
fetching: false,
success: false,
error: action.payload
      };
    default:
      return state;
  }

}

export function Invitees(state = INVITEE_LISTING_STATE, action) {
  switch (action.type) {
    case C.FETCH_INVITEE_INITIATED:
      return {
        ...state,
fetching: true,
success: false,
error: null
      };
    case C.FETCH_INVITEE_LIST_SUCCESS:
      return {
        ...state,
data: action.payload,
fetching: false,
success: true,
error: null
      };
    case C.FETCH_INVITEE_LIST_FAILURE:
      return {
        ...state,
fetching: false,
success: false,
error: action.payload
      };
    case C.UPDATE_INVITEE_DATA:
      const inviteData = { ...state.data };
      inviteData.invites = [];
      return {
        ...state,
data: { ...inviteData }
      }
    default:
      return state;
  }

}

/**
 * refer merchant reducer responsible for refer merchant action
 * @param  {object} state  initial state
 * @param  {object} action redux action object
 * @return {object}        redux store state
 */
export function referMerchantReducer(state = REFER_MERCHANT_STATE, action) {
  switch (action.type) {
    case C.REFER_MERCHANT_INITIATED:
      return {
        ...state,
fetching: true,
success: false,
error: null
      };
    case C.REFER_MERCHANT_SUCCESS:
      return {
        ...state,
data: action.payload,
fetching: false,
success: true,
error: null
      };
    case C.REFER_MERCHANT_FAILURE:
      return {
        ...state,
fetching: false,
success: false,
error: action.payload
      };
    default:
      return state;
  }
}

export function sendSmsLinkReducer(state = GENERIC_STATE, action) {
  switch (action.type) {
    case C.SEND_SMS_LINK_REQUEST_INITIATED:
      return {
        ...state,
fetching: true,
success: false,
error: null
      };
    case C.SEND_SMS_LINK_REQUEST_SUCCESS:
      return {
        ...state,
data: action.payload,
fetching: false,
success: true,
error: null
      };
    case C.SEND_SMS_LINK_REQUEST_FAILURE:
      return {
        ...state,
fetching: false,
success: false,
error: action.payload
      };
    default:
      return state;
  }
}

export function createAppReducer(state = GENERIC_STATE, action){
  switch(action.type) {
    case C.CREATE_APP_SUBMIT_INITIATED:
      return {
        ...state, fetching: true, success: false, error: null,
      };
    case C.CREATE_APP_SUCCESS:
      return {
        ...state, data: action.payload, fetching: false, success: true, error: null
      };
    case C.CREATE_APP_FAILURE:
      return {
        ...state, fetching: false, success: false, error: action.payload
      }
    case C.CREATE_INCORRECT_PASSWORD:
      return {
        ...state, fetching: false, success: false, error: { value: 1, message: 'Incorrect Password'}
      }
    default:
      return state;
  }
}

export function fetchAppDetailsReducer(state = CLIENT_APP_DEFAULT_STATE, action){
  switch(action.type) {
    case C.FETCH_APP_DETAILS_INITIATED:
      return {
        ...state, fetching: true, success: false, error: null,
      };
    case C.FETCH_APP_DETAILS_SUCCESS:
      return {
        ...state, data: action.payload, fetching: false, success: true, error: null
      };
    case C.FETCH_APP_DETAILS_FAILURE:
      return {
        ...state, fetching: false, success: false, error: action.payload
      }
    case C.APPLICATION_DETAILS_INITIATED:
      return {
        ...state, fetching: true, success: false, error: null,
      }
    case C.APPLICATION_DETAILS_SUCCESS:
      return{
        ...state, data: action.payload, fetching: false, success: true, error: null
      }
    case C.APPLICATION_DETAILS_FAILURE:
      return {
        ...state, fetching: false, success: false, error: action.payload
      }
    case C.SHOW_INCORRECT_PASSWORD:
      return {
        ...state, fetching: false, success: false, error: { value: 1, message: 'Incorrect Password'}
      }
    default:
      return state;
  }
}

export function brandingDetailsReducer(state = GENERIC_STATE, action){
  switch(action.type){
    case C.BRANDING_DETAILS_INITIATED:
      return { ...state, fetching: true, success: false };
    case C.BRANDING_DETAILS_SUCCESS:
      return { ...state, fetching: false, success: true, data: action.payload };
    case C.BRANDING_DETAILS_FAILURE:
      return { ...state, fetching: false, error: action.payload }
    default:
    return state;
  }
}

export function createMerchantStaffPartnerReducer(state = GENERIC_STATE, action) {
  switch(action.type){
    case C.CREATE_MERCHANT_STAFF_INITIATED:
      return { ...state, fetching: true, success: false };
    case C.CREATE_MERCHANT_STAFF_SUCCESS:
      return { ...state, fetching: false, success: true, data: action.payload};
    case C.CREATE_MERCHANT_STAFF_FAILURE:
      return { ...state, fetching: false, error: action.payload}
    default:
      return state;
  }
}

function selectResellerDetails(state) {
  const { reseller } = state.dashboard;
  if (reseller.data) {
    return reseller.data.reseller_detail || {};
  }
  return {};
}


function selectBankDetails(state) {
    const { reseller } = state.dashboard;
    if (reseller.data) {
        return reseller.data.bank_detail || {};
    }
    return {};
}

function selectReseller(state) {
  const { reseller } = state.dashboard;
  return reseller.data || {};
}

function selectResellerAddress(state) {
  const { reseller } = state.dashboard;
  if (reseller.data) {
    return reseller.data.registration_address || {};
  }
  return {};
}


export const selectors = {
  selectResellerDetails,
  selectReseller,
  selectResellerAddress,
  selectBankDetails
};


export default combineReducers({
  merchants: merchantListReducer,
  reseller: resellerReducer,
  referredMerchant: referMerchantReducer,
  smsLinkRequest: sendSmsLinkReducer,
  inviteUser: inviteUser,
  Invitees: Invitees,
  inviteUserUpdate: inviteUserUpdate,
  appRegistration: createAppReducer,
  appDetails: fetchAppDetailsReducer,
  brandingDetails: brandingDetailsReducer,
  createMerchantStaffPartner: createMerchantStaffPartnerReducer
});
